import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { selectUser } from '../../store/selectors';
import { FaUser, FaSignOutAlt, FaCog } from 'react-icons/fa';
import { useLogout } from '../../api/auth';
import NotificationBell from './NotificationBell';
import styles from './Header.module.css';

const Header = () => {
  const navigate = useNavigate();
  const { execute: logout } = useLogout();

  const user = useAppSelector(selectUser);

  const userName = user?.name || 'John Doe';
  const userRole = user?.role || 'Admin';

  const handleLogout = () => {
    logout({
      refreshToken: localStorage.getItem('refreshToken'),
    });
  };

  const getInitials = (name) =>
    name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);

  return (
    <div className={styles.header}>
      <div className={styles.leftSection}>
        <div className={styles.avatar}>{getInitials(userName)}</div>

        <div className={styles.userInfo}>
          <h2 className={styles.userName}>{userName}</h2>
          <p className={styles.userRole}>• {userRole.toUpperCase()}</p>
        </div>
      </div>

      <div className={styles.rightSection}>
        <NotificationBell />

        <button className={styles.menuItem} onClick={() => navigate('/profile')}>
          <FaUser />
          <span>Profile</span>
        </button>

        <button className={styles.menuItem} onClick={() => navigate('/settings')}>
          <FaCog />
          <span>Settings</span>
        </button>

        <button
          className={`${styles.menuItem} ${styles.logoutItem}`}
          onClick={handleLogout}
        >
          <FaSignOutAlt />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Header;
